var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNarrowArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 936",
    d: "M9.443 11.705a1.024 1.024 0 010-1.426l3.194-3.27H1a1 1 0 01-1-1v-.016a1 1 0 011-1h11.638l-3.2-3.273a1.026 1.026 0 010-1.426.97.97 0 011.393 0l4.88 4.994a1.026 1.026 0 010 1.426l-.024.023-4.853 4.967a.972.972 0 01-.7.295.97.97 0 01-.691-.294z"
  })));
}
export default SvgNarrowArrow;